/**
 * Represents WorkerMessenger
 * @description handles the communication between the PWA and the service worker
 */
class WorkerMessenger {
	/**
	 * Clear all cache storage related to the current context
	 */
	clearContextCaches() {
		if (navigator.serviceWorker && navigator.serviceWorker.controller) {
			navigator.serviceWorker.controller.postMessage('cleanContext');
		}
	}
}

export default new WorkerMessenger();
